module.exports = {"id":"dp2_2l5q1","category":"2.2","text":"Digital Sharing","instructions":"Have you contributed to a website or online repository by sharing information in the last 5 years?","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"questionType":"PickOne","random":false,"options":[{"id":"dp2_2l5q1-a1","text":"No","score":3.4},{"id":"dp2_2l5q1-a2","text":"Not sure","score":3.4},{"id":"dp2_2l5q1-a3","text":"Yes","score":5.6}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat2.2/l5q1.json
// module id = 1022
// module chunks = 41